export default __webpack_public_path__ + "static/media/a-natual-mockup.4921a5c2.png";